import { render } from "./MyTopheader.vue?vue&type=template&id=509672cc"
import script from "./MyTopheader.vue?vue&type=script&lang=js"
export * from "./MyTopheader.vue?vue&type=script&lang=js"

import exportComponent from "F:\\weblocal\\taxe.local\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__